import Component from './route-component';
import Enhance from '../core/enhance'
import React from 'react'


/**
 * 根路由
 */
class RouterRoot extends Component {
    
    /**
     *
     * @return {*}
     */
    render() {
        return this.props.children;
    }
    
    
}

Enhance(RouterRoot, {}, 'RouterRoot');
export default RouterRoot;
